module.exports = __webpack_public_path__ + "img/dp.ba8db3bb.jpg";